import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AdminLayout() {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-gray-800 text-white">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <h1 className="text-xl md:text-2xl font-bold">Painel Administrativo</h1>
          <div className="flex items-center space-x-4">
            <span className="hidden md:inline">{currentUser?.email}</span>
            <button
              onClick={handleLogout}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Sair
            </button>
          </div>
        </div>
        <nav className="bg-gray-700">
          <div className="container mx-auto px-4">
            <ul className="flex space-x-6 py-2">
              <li>
                <Link to="/admin/dashboard" className="text-gray-200 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin/content" className="text-gray-200 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Conteúdo
                </Link>
              </li>
              <li>
                <Link to="/admin/contacts" className="text-gray-200 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Contatos
                </Link>
              </li>
              <li>
                <Link to="/admin/seo" className="text-gray-200 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  SEO
                </Link>
              </li>
              <li>
                <Link to="/admin/settings" className="text-gray-200 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                  Configurações
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <main className="min-h-[calc(100vh-140px)] bg-gray-100">
        <div className="mx-auto p-4 sm:px-6 lg:px-8 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}